import sha256 from 'fast-sha256';

// The MIT License (MIT)
//
// Copyright (c) 2013 Artem S Vybornov
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

// The MIT License (MIT)
// Copyright base-x contributors (c) 2016
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

// https://github.com/cryptocoinjs/base-x/blob/master/index.js
// base-x encoding
// Forked from https://github.com/cryptocoinjs/bs58
// Originally written by Mike Hearn for BitcoinJ
// Copyright (c) 2011 Google Inc
// Ported to JavaScript by Stefan Thomas
// Merged Buffer refactorings from base58-native by Stephen Pair
// Copyright (c) 2013 BitPay Inc

// Copyright (c) 2017 Pieter Wuille
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

// ISC License

// Copyright (c) 2013-2016 The btcsuite developers

// Permission to use, copy, modify, and distribute this software for any
// purpose with or without fee is hereby granted, provided that the above
// copyright notice and this permission notice appear in all copies.

// THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
// WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
// MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
// ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
// WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
// ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
// OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.

const CHARSET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l",
  CHARSET_MAP = {
    q: 0,
    p: 1,
    z: 2,
    r: 3,
    y: 4,
    9: 5,
    x: 6,
    8: 7,
    g: 8,
    f: 9,
    2: 10,
    t: 11,
    v: 12,
    d: 13,
    w: 14,
    0: 15,
    s: 16,
    3: 17,
    j: 18,
    n: 19,
    5: 20,
    4: 21,
    k: 22,
    h: 23,
    c: 24,
    e: 25,
    6: 26,
    m: 27,
    u: 28,
    a: 29,
    7: 30,
    l: 31
  },
  ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz",
  ALPHABET_MAP = {
    1: 0,
    2: 1,
    3: 2,
    4: 3,
    5: 4,
    6: 5,
    7: 6,
    8: 7,
    9: 8,
    A: 9,
    B: 10,
    C: 11,
    D: 12,
    E: 13,
    F: 14,
    G: 15,
    H: 16,
    J: 17,
    K: 18,
    L: 19,
    M: 20,
    N: 21,
    P: 22,
    Q: 23,
    R: 24,
    S: 25,
    T: 26,
    U: 27,
    V: 28,
    W: 29,
    X: 30,
    Y: 31,
    Z: 32,
    a: 33,
    b: 34,
    c: 35,
    d: 36,
    e: 37,
    f: 38,
    g: 39,
    h: 40,
    i: 41,
    j: 42,
    k: 43,
    m: 44,
    n: 45,
    o: 46,
    p: 47,
    q: 48,
    r: 49,
    s: 50,
    t: 51,
    u: 52,
    v: 53,
    w: 54,
    x: 55,
    y: 56,
    z: 57
  };

function parseAndConvertCashAddress(addr) {
  const [r, e] = addr.split(':');
  for (var t = new Array(e.length), n = 0; n < e.length; n++) {
    if (void 0 === CHARSET_MAP[e[n]]) throw "Unexpected character!";
    t[n] = CHARSET_MAP[e[n]]
  }
  if ("bitcoincash" == r) var o = [2, 9, 20, 3, 15, 9, 14, 3, 1, 19, 8, 0],
    a = !0;
  else o = [2, 3, 8, 20, 5, 19, 20, 0], a = !1;
  var c = o.concat(t),
    s = polyMod(c);
  if (0 !== s[0] || 0 !== s[1]) {
    for (var d = 0; d < c.length; d++)
      for (var f = 1; f < 32; f++) {
        c[d] ^= f;
        var h = polyMod(c);
        if (0 === h[0] && 0 === h[1]) return correctedAddress = rebuildAddress(c), document.getElementById("correctedButton").style = "", "";
        c[d] ^= f
      }
    throw "Can't correct errors!"
  }
  var i = convertBits(t.slice(0, -8), 5, 8, !1);
  return craftOldAddress(i[0] >> 3, i.slice(1, 21), a)
}

function craftOldAddress(r, e, t) {
  return CheckEncodeBase58(e, t ? 0 == r ? 0 : 5 : 0 == r ? 111 : 196)
}

function CheckEncodeBase58(r, e) {
  var t = [e];
  t = t.concat(r);
  var n = sha256(Uint8Array.from(t)),
    o = sha256(n);
  return EncodeBase58Simplified(t = t.concat(Array.from(o).slice(0, 4)))
}

function EncodeBase58Simplified(r) {
  for (var e = [0], t = 0; t < r.length; t++) {
    for (var n = 0, o = r[t]; n < e.length; n++) o += e[n] << 8, e[n] = o % 58, o = o / 58 | 0;
    for (; o > 0;) e.push(o % 58), o = o / 58 | 0
  }
  var a = "";
  for (t = 0; t < r.length && 0 === r[t]; t++) a = a.concat("1");
  for (var c = e.length - 1; c >= 0; c--) a = a.concat(ALPHABET[e[c]]);
  return a
}

function parseAndConvertOldAddress(r) {
  for (var e = [0], t = 0; t < r.length; t++) {
    var n = ALPHABET_MAP[r[t]];
    if (void 0 === n) throw "Unexpected character!";
    for (var o = 0; o < e.length; o++) n += 58 * e[o], e[o] = 255 & n, n >>= 8;
    for (; n > 0;) e.push(255 & n), n >>= 8
  }
  for (t = 0; t < r.length && "1" === r[t]; t++) e.push(0);
  var a = (e = e.reverse())[0],
    c = sha256(Uint8Array.from(e.slice(0, -4))),
    s = sha256(c);
  if (s[0] != e[e.length - 4] || s[1] != e[e.length - 3] || s[2] != e[e.length - 2] || s[3] != e[e.length - 1]) throw "Address checksum doesn't match! Did you type it wrong?";
  var d = e.slice(1, e.length - 4);
  if (0 == a) return craftCashAddress(0, d, !0);
  if (5 == a) return craftCashAddress(1, d, !0);
  if (111 == a) return craftCashAddress(0, d, !1);
  if (196 == a) return craftCashAddress(1, d, !1);
  if (28 == a) return craftCashAddress(0, d, !0);
  if (40 == a) return craftCashAddress(1, d, !0);
  throw "Unknown version byte"
}

function packCashAddressData(r, e) {
  return convertBits([r << 3].concat(e), 8, 5, !0)
}

function convertBits(r, e, t, n) {
  for (var o = 0, a = 0, c = [], s = (1 << t) - 1, d = (1 << e + t - 1) - 1, f = 0; f < r.length; f++) {
    var h = r[f];
    if (h < 0 || h >>> e != 0) throw "convertBits error!";
    for (o = (o << e | h) & d, a += e; a >= t;) a -= t, c.push(o >>> a & s)
  }
  if (n) a > 0 && c.push(o << t - a & s);
  else if (a >= e || 0 != (o << t - a & s)) throw "convertBits error!";
  return c
}

function craftCashAddress(r, e, t) {
  var n = packCashAddressData(r, e);
  if (1 == t) var o = [2, 9, 20, 3, 15, 9, 14, 3, 1, 19, 8, 0];
  else o = [2, 3, 8, 20, 5, 19, 20, 0];
  for (var a = polyMod(o.concat(n).concat([0, 0, 0, 0, 0, 0, 0, 0])), c = a[0], s = a[1], d = new Array(8), f = 7; f > 5; f--) d[f] = 31 & s, s >>>= 5, s |= (31 & c) << 27, c >>>= 5;
  for (; f > 0; f--) d[f] = 31 & s, s >>>= 5;
  d[0] = s;
  var h = n.concat(d),
    i = "";
  i = 1 == t ? "bitcoincash:" : "bchtest:";
  for (f = 0; f < h.length; f++) i = i.concat(CHARSET[h[f]]);
  if (54 == i.length || 50 == i.length) return i;
  throw "Unexpected converted address length!"
}

function polyMod(r) {
  for (var e = 0, t = 1, n = 0, o = 0; o < r.length; o++) n = e >>> 3, e = (e &= 7) << 5 | t >>> 27, t &= 134217727, t <<= 5, t ^= r[o], 0 !== n && (1 & n && (e ^= 152, t ^= 4072443489), 2 & n && (e ^= 121, t ^= 3077413346), 4 & n && (e ^= 243, t ^= 1046459332), 8 & n && (e ^= 174, t ^= 783016616), 16 & n && (e ^= 30, t ^= 1329849456));
  return [e, 1 ^ t]
}

function rebuildAddress(r) {
  for (var e = "", t = 0; 0 != r[t] && t < r.length;) e = e.concat(String.fromCharCode(96 + r[t])), t++;
  for (e = e.concat(":"), t++; t < r.length; t++) e = e.concat(CHARSET[r[t]]);
  return e
}

export {
  parseAndConvertCashAddress
}